import React from "react"
import lodash from "lodash"
import { useRecoilState } from "recoil"

import { stateStateFamily } from "./state"

const useTariffDialog = id => {
  const [state, setState] = useRecoilState(stateStateFamily(id))

  const { isOpen, onSelect = lodash.noop, ...rest } = state || {}

  const open = values => setState({ ...values, isOpen: true })

  const close = () => setState({ isOpen: false })

  return { open, close, isOpen, onSelect, ...rest }
}

export default useTariffDialog
